import  { FC, Fragment} from 'react';
import { Form } from 'react-bootstrap';
interface AdditionalProps {
    formik?: any;
}
interface GenericInputProps extends AdditionalProps {
    type: string,name: string, label: string, onChange: any, disabled: boolean
}
const GenericInput: FC<GenericInputProps> = ({formik, type, name, label, onChange, disabled }) => {
    return (
        <Fragment>
            <Form.Label htmlFor="name" className="mb-1 fw-normal">{label}</Form.Label>
            <Form.Control 
                type={type} 
                {...formik.getFieldProps(name)}
                onChange={onChange}
                disabled={disabled}
                className={`${(formik.touched[name] && formik.errors[name]) && "is-invalid"} mb-2`}
            />
            <Form.Control.Feedback id={formik.values[name]} className="invalid-feedback">
                {formik.errors[name]}
            </Form.Control.Feedback>
        </Fragment>
    );
};

export default GenericInput;
